import React, { useState, useEffect } from 'react';
import breathings from './breathing.json';
import './Theraphy.css';

function Breathing() {
  const [selectedId, setSelectedId] = useState('');
  const breathing = breathings.find(b => b.id === selectedId);

  useEffect(() => {
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length === 0) {
        setTimeout(loadVoices, 100);
      }
    };
    loadVoices();
  }, []);

  const speak = (text, langCode) => {
    const synth = window.speechSynthesis;
    const voices = synth.getVoices();

    // Match voice by language code
    const voice = voices.find(v => v.lang === langCode);

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = langCode;
    if (voice) utterance.voice = voice;

    synth.speak(utterance);
  };

  return (
    <div className="app">
      <h1>💨 Breathing Guide</h1>
      <select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}>
        <option value="">Select a breathing exercise</option>
        {breathings.map(b => (
          <option key={b.id} value={b.id}>{b.title}</option>
        ))}
      </select>

      {breathing && (
        <div className="breathing-container">
          {/* English */}
                    <div> <h1><u>In English</u></h1></div>

          <div className="language-block">
            <h2>{breathing.title}</h2>
            {breathing.english.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{breathing.english.moralHeading}</h3>
            <p>{breathing.english.moral}</p>

            <button onClick={() => speak([...breathing.english.lines, breathing.english.moral].join(' '), 'en-US')}>
              🔊 Read Aloud (English)
            </button>
          </div>

          {/* Hindi */}
          <div> <h1><u>In Hindi</u></h1></div>
          <div className="language-block">
            <h2>{breathing.hindi.title}</h2>
            {breathing.hindi.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{breathing.hindi.moralHeading}</h3>
            <p>{breathing.hindi.moral}</p>
            <button onClick={() => speak([...breathing.hindi.lines, breathing.hindi.moral].join(' '), 'hi-IN')}>
              🔊 Read Aloud (Hindi)
            </button>
          </div>

          {/* Telugu */}
          <div> <h1><u>In Telugu</u></h1></div>
          <div className="language-block">
            <h2>{breathing.telugu.title}</h2>
            {breathing.telugu.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{breathing.telugu.moralHeading}</h3>
            <p>{breathing.telugu.moral}</p>

            <button onClick={() => speak([...breathing.telugu.lines, breathing.telugu.moral].join(' '), 'te-IN')}>
              🔊 Read Aloud (Telugu)
            </button>
          </div>

          {/* French */}
          <div> <h1><u>In French</u></h1></div>
          <div className="language-block">
            <h2>{breathing.french.title}</h2>
            {breathing.french.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{breathing.french.moralHeading}</h3>
            <p>{breathing.french.moral}</p>

            <button onClick={() => speak([...breathing.french.lines, breathing.french.moral].join(' '), 'fr-FR')}>
              🔊 Read Aloud (French)
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Breathing;
